export default {
      id: "Icon--spinner-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--spinner",
      toString: function () {
        return this.url;
      }
    }